@if (blockedMessage) {
  <div class="page-blocked">
    <p>{{ blockedMessage }}</p>
  </div>
} @else {
@if (!done) {
  <div class="restaurant-loader">
    <div class="loader">
      <fa-icon [icon]="faUtensils" [spin]="true"></fa-icon>
    </div>
  </div>
}

@if (done) {
  <div class="main-container">
    <div class="main-body">
      <div class="logo-container">
        <label>RESERVAS</label>
        @if (logoPath) {
          <img [src]="logoPath"/>
        }
      </div>
      @if (reservationRule && !tacAccepted) {
        <div class="terms">
          <label>CONDIÇÕES:</label>
          <div class="text">
            <textarea id="tac" class="form-control" [ngModel]="reservationRule.terms_and_conditions" readonly="true"></textarea>
          </div>
          <button class="btn btn-md btn-primary" (click)="tacAccepted = true">
            Li e aceito
          </button>
        </div>
      }
      @if (tacAccepted && !(reservation.id > 0)) {
        <div class="reservation-details">
          <label>Dia da reserva:</label>
          <bs-datepicker-inline [bsValue]="selectedDay" [minDate]="today"
            [bsConfig]="bsConfig" [maxDate]="maxDate"
            (bsValueChange)="onDateSelection($event)">
          </bs-datepicker-inline>
          @if (errors && errors.field == 'day') {
            <div class="error">
              <br/>
              {{errors.message}}
            </div>
          }
          <br/>
          <br/>
          @if (!(errors && errors.field == 'day')) {
            <div>
              <label>Horário</label>
              <div class="input-container">
                <select class="form-control" [(ngModel)]="selectedTime" (change)="timeChanged($event)">
                  <option value="">Selecione</option>
                  @for (sched of availSchedules; track sched) {
                    <option [value]="sched.time" [disabled]="sched.disabled">{{sched.time}} {{sched.disabled ? "(Indisponível)" : ""}}</option>
                  }
                </select>
              </div>
              <br/>
              <br/>
              @if (!(errors && errors.field == 'time') && reservation.schedule) {
                <div>
                  <label>Ambiente</label>
                  <div class="input-container">
                    <select class="form-control" [(ngModel)]="reservation.building_region_id" (change)="regionChanged($event)">
                      <option value="0">Selecione</option>
                      @for (br of buildingRegions; track br) {
                        <option [value]="br.id" [disabled]="br.full || br.status != 'ok'">
                          {{br.name}}
                          @if (br.full) {
                            <span> (Esgotado)</span>
                          }
                          @if (br.status == 'under_construction') {
                            <span> (Fechado para Reforma)</span>
                          }
                          @if (br.status == 'closed_temporarily') {
                            <span> (Fechado temporariamente)</span>
                          }
                          @if (br.status == 'restricted') {
                            <span> (Entre em Contato)</span>
                          }
                        </option>
                      }
                    </select>
                  </div>
                  <br/>
                  <br/>
                  @if (!(errors && errors.field == 'region')) {
                    <div>
                      <label>N&ordm; de pessoas</label>
                      <div class="input-container">
                        <select class="form-control" [(ngModel)]="reservation.people_qty" (change)="peopleQtyChanged($event)">
                          <option value="0">Selecione</option>
                          @for (n of availPeopleQty; track n) {
                            <option [value]="n">{{n}} pessoa{{n > 1 ? 's' : ''}}</option>
                          }
                        </select>
                      </div>
                    </div>
                  }
                  <br/>
                  <br/>
                  @if (reservation.building_region_id && reservation.people_qty > 0) {
                    <div>
                      <label>Nome e Sobrenome</label>
                      <div class="input-container">
                        <input type="text" class="form-control" [(ngModel)]="reservation.customer_name"/>
                      </div>
                      <br/>
                      <br/>
                      <label>Telefone</label>
                      <div class="input-container">
                        <input type="text" class="form-control" [(ngModel)]="reservation.customer_phone" mask="(00) 0 0000-0000" placeholder="(99) 9 9999-9999" />
                      </div>
                      <br/>
                      <br/>
                      <label>Alguma observação?</label>
                      <div class="input-container">
                        <textarea class="form-control" rows="4" [(ngModel)]="reservation.customer_description" placeholder="Exemplo: Aniversário de casamento. Pessoa com necessidades especiais. Mesa mais privativa">
                        </textarea>
                      </div>
                      <br/>
                      <br/>
                      <div class="button-container">
                        <button class="btn btn-lg btn-success" (click)="sendReservation()" [disabled]="sending || reservation.customer_name < 6 || reservation.customer_phone.length < 11 || !reservation.building_region_id || !reservation.schedule || reservation.people_qty < 1">
                          @if (!sending) {
                            <span>ENVIAR</span>
                          }
                          @if (sending) {
                            <fa-icon [icon]="faSpinner" [animation]="'spin'" size="lg"></fa-icon>
                          }
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if(reservation.id > 0) {
        <div class="reservation-details">
          <div class="success-text">RESERVA EFETUADA COM SUCESSO!</div>
          <div class="success-buttons">
            <button class="btn btn-lg btn-success" (click)="openWapp()">
              <fa-icon [icon]="faWhatsapp" size="lg"></fa-icon> ACOMPANHAR RESERVA
            </button>
            <br/>
            <br/>
            <button class="btn btn-lg btn-secondary" (click)="dontOpenWapp()">
              <small>não receber informações</small>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
}
}
